import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import RealisationsPage from './pages/RealisationsPage';
import WebDevelopmentPage from './pages/WebDevelopmentPage';
import ReferencementPage from './pages/ReferencementPage';
import DesignGraphiquePage from './pages/DesignGraphiquePage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';

function App() {
  useEffect(() => {
    // Smooth scroll behavior for the whole document
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/realisations" element={<RealisationsPage />} />
        <Route path="/developpement-web" element={<WebDevelopmentPage />} />
        <Route path="/referencement" element={<ReferencementPage />} />
        <Route path="/design-graphique" element={<DesignGraphiquePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </div>
  );
}

export default App;

